import { render, staticRenderFns } from "./AccountBondObjDetail.vue?vue&type=template&id=05a0bdf4&scoped=true"
import script from "./AccountBondObjDetail.vue?vue&type=script&lang=js"
export * from "./AccountBondObjDetail.vue?vue&type=script&lang=js"
import style0 from "./AccountBondObjDetail.vue?vue&type=style&index=0&id=05a0bdf4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05a0bdf4",
  null
  
)

export default component.exports